export const stringToPercentage = (value?: string): string => {
  if (!value) return (0).toString();

  const decimal = parseFloat(value);
  const percentage = decimal * 100;

  return percentage.toFixed(2).toString();
};
